const middleware = {}

middleware['affiliateDetection'] = require('../middleware/affiliateDetection.js')
middleware['affiliateDetection'] = middleware['affiliateDetection'].default || middleware['affiliateDetection']

middleware['cookieDetection'] = require('../middleware/cookieDetection.js')
middleware['cookieDetection'] = middleware['cookieDetection'].default || middleware['cookieDetection']

middleware['pageQueryString'] = require('../middleware/pageQueryString.js')
middleware['pageQueryString'] = middleware['pageQueryString'].default || middleware['pageQueryString']

export default middleware
